import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./About.css";


const About = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <section class="about container" id="about">
      <div data-aos="fade-down" data-aos-duration="2000">
        <h1 class="heading">
          {" "}
          <span>about</span> me{" "}
        </h1>
      </div>

      <div class="row">
        <div class="info" data-aos="fade-right" data-aos-duration="2000">
          <h3>

            <span> Name : </span> Jahidul Islam Zim
          </h3>
          <h3>

            <span> Age : </span> 19+
          </h3>
          <h3>

            <span> Qualification : </span> Department Of Science (HSC)
          </h3>
          <h3>

            <span> Post : </span> Jr. MERN Stack Developer
          </h3>
          <h3>

            <span> Language : </span> Bangla And English
          </h3>
          <div className="">
          <div className="social-icon-section">
          <div
            data-aos="fade-right"
            data-aos-duration="3000"
            data-aos-anchor-placement="center-bottom"
          >
            <a
              href="https://www.facebook.com/jahidulislamzim.dev"
              target="_blank"
              rel="noreferrer"
            >
              <i class="fa-brands fa-facebook-f social-icon"></i>
            </a>
          </div>
          <div
            data-aos="fade-up"
            data-aos-duration="3000"
            data-aos-anchor-placement="center-bottom"
          >
            <a
              href="https://github.com/jahidulislamzim/"
              target="_blank"
              rel="noreferrer"
            >
              <i class="fa-brands fa-github social-icon"></i>
            </a>
          </div>
          <div
            data-aos="fade-left"
            data-aos-duration="3000"
            data-aos-anchor-placement="center-bottom"
          >
            <a
              href="https://www.linkedin.com/in/jahidulislamzim/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa-brands fa-linkedin-in social-icon"></i>
            </a>
          </div>
        </div>
          </div>
        </div>

        <div class="counter">
          <div
            className="parent-box"
            data-aos="fade-down"
            data-aos-anchor-placement="center-bottom"
            data-aos-duration="2000"
          >
            <div class="box">
              <span>1+</span>
              <h3>years of experience</h3>
            </div>
          </div>

          <div
            className="parent-box"
            data-aos="fade-down"
            data-aos-anchor-placement="center-bottom"
            data-aos-duration="2000"
          >
            <div class="box">
              <span>18+</span>
              <h3>porject completed</h3>
            </div>
          </div>

          <div
            className="parent-box"
            data-aos="fade-down"
            data-aos-anchor-placement="center-bottom"
            data-aos-duration="2000"
          >
            <div class="box">
              <span>5+</span>
              <h3>happy clients</h3>
            </div>
          </div>

          <div
            className="parent-box"
            data-aos="fade-down"
            data-aos-anchor-placement="center-bottom"
            data-aos-duration="2000"
          >
            <div class="box">
              <span>1+</span>
              <h3>awards won</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
